<template>
  <div class="revenue-statistics">
    <!-- 面包屑导航已注释，因为组件在首页显示时不需要导航
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据统计</el-breadcrumb-item>
      <el-breadcrumb-item>收入统计</el-breadcrumb-item>
    </el-breadcrumb>
    -->

    <!-- 查询条件 -->
    <el-card style="margin-top: 20px">
      <el-form :inline="true" :model="queryForm" class="query-form">
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="queryForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item label="店铺选择">
          <el-select
            v-model="queryForm.storeIds"
            multiple
            collapse-tags
            placeholder="请选择店铺（可多选）"
            style="width: 300px"
            clearable
            filterable
          >
            <el-option label="全部店铺" value="all" />
            <el-option
              v-for="store in storeList"
              :key="store.id"
              :label="store.storename"
              :value="store.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="统计维度">
          <el-radio-group v-model="queryForm.dimension">
            <el-radio label="day">按天</el-radio>
            <el-radio label="week">按周</el-radio>
            <el-radio label="month">按月</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button type="success" icon="el-icon-download" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据概览卡片 -->
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="6">
        <el-card class="summary-card">
          <div class="summary-title">总营业额</div>
          <div class="summary-value">¥{{ summaryData.totalRevenue }}</div>
          <div class="summary-trend" :class="summaryData.revenueTrend >= 0 ? 'trend-up' : 'trend-down'" v-if="!isNaN(summaryData.revenueTrend) && summaryData.revenueTrend !== 0">
            <i :class="summaryData.revenueTrend >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
            {{ Math.abs(summaryData.revenueTrend).toFixed(1) }}%
          </div>
          <div class="summary-trend" style="color: #909399;" v-else>
            <i class="el-icon-minus"></i>
            暂无对比数据
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="summary-card">
          <div class="summary-title">平均日营业额</div>
          <div class="summary-value">¥{{ summaryData.avgDailyRevenue }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="summary-card">
          <div class="summary-title">订单总数</div>
          <div class="summary-value">{{ summaryData.totalOrders }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="summary-card">
          <div class="summary-title">客单价</div>
          <div class="summary-value">¥{{ summaryData.avgOrderAmount }}</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-card style="margin-top: 20px">
      <div slot="header" class="clearfix">
        <span>收入趋势图</span>
        <el-radio-group v-model="chartType" size="small" style="float: right">
          <el-radio-button label="bar">柱状图</el-radio-button>
          <el-radio-button label="line">折线图</el-radio-button>
        </el-radio-group>
      </div>
      <div ref="revenueChart" style="width: 100%; height: 500px"></div>
    </el-card>

    <!-- 店铺收入排行 -->
    <el-card style="margin-top: 20px">
      <div slot="header">
        <span>店铺收入排行</span>
      </div>
      <el-table :data="storeRankingData" stripe style="width: 100%">
        <el-table-column type="index" label="排名" width="80" />
        <el-table-column prop="storeName" label="店铺名称" />
        <el-table-column prop="city" label="城市" width="120" />
        <el-table-column prop="revenue" label="营业额" width="150" sortable :sort-method="sortByRevenue">
          <template slot-scope="scope">
            <span style="color: #67C23A; font-weight: bold">¥{{ scope.row.revenue }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="订单数" width="120" sortable :sort-method="sortByOrderCount" />
        <el-table-column prop="avgAmount" label="客单价" width="120" sortable :sort-method="sortByAvgAmount">
          <template slot-scope="scope">¥{{ scope.row.avgAmount }}</template>
        </el-table-column>
        <el-table-column prop="weekTrend" label="周环比" width="120">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.weekTrend >= 0 ? '#67C23A' : '#F56C6C' }">
              <i :class="scope.row.weekTrend >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
              {{ Math.abs(scope.row.weekTrend) }}%
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'RevenueStatistics',
  data() {
    return {
      // 查询表单
      queryForm: {
        dateRange: [],
        storeIds: ['all'],
        dimension: 'day'
      },
      // 日期选择器配置
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '近三年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // 店铺列表
      storeList: [],
      // 图表类型
      chartType: 'bar',
      // 图表实例
      chartInstance: null,
      // 汇总数据
      summaryData: {
        totalRevenue: '0.00',
        avgDailyRevenue: '0.00',
        totalOrders: 0,
        avgOrderAmount: '0.00',
        revenueTrend: 0
      },
      // 图表数据
      chartData: {
        dates: [],
        series: []
      },
      // 店铺排行数据
      storeRankingData: []
    }
  },
  created() {
    this.initDateRange()
    this.loadStoreList()
    this.loadStatisticsData()
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  },
  watch: {
    chartType() {
      this.updateChart()
    }
  },
  methods: {
    // 初始化日期范围（默认最近7天）
    initDateRange() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.queryForm.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ]
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 加载店铺列表
    async loadStoreList() {
      try {
        const { data: res } = await this.$http.get('store/')
        if (res.status === 0) {
          this.storeList = res.data || []
        }
      } catch (error) {
        console.error('加载店铺列表失败:', error)
      }
    },

    // 加载统计数据
    async loadStatisticsData() {
      try {
        const params = {
          startDate: this.queryForm.dateRange[0],
          endDate: this.queryForm.dateRange[1],
          storeIds: this.queryForm.storeIds.includes('all') ? [] : this.queryForm.storeIds,
          dimension: this.queryForm.dimension
        }

        const { data: res } = await this.$http.post('statistics/revenue/', params)
        
        if (res.status === 0) {
          // 更新汇总数据
          this.summaryData = res.summary || this.summaryData
          
          // 更新图表数据
          this.chartData = res.chartData || this.chartData
          this.updateChart()
          
          // 更新店铺排行
          this.storeRankingData = res.storeRanking || []
        } else {
          this.$message.error(res.message || '加载数据失败')
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
        this.$message.error('加载数据失败，请稍后重试')
      }
    },

    // 初始化图表
    initChart() {
      if (this.$refs.revenueChart) {
        this.chartInstance = echarts.init(this.$refs.revenueChart)
        this.updateChart()
      }
    },

    // 更新图表
    updateChart() {
      if (!this.chartInstance) return

      const option = {
        title: {
          text: '收入趋势统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let result = `${params[0].axisValue}<br/>`
            params.forEach(item => {
              result += `${item.marker}${item.seriesName}: ¥${item.value}<br/>`
            })
            return result
          }
        },
        legend: {
          data: this.chartData.series.map(s => s.name),
          top: 30
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: 80,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.chartData.dates,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '金额（元）',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: this.chartData.series.map(item => ({
          name: item.name,
          type: this.chartType,
          data: item.data,
          smooth: true,
          emphasis: {
            focus: 'series'
          }
        })),
        toolbox: {
          feature: {
            saveAsImage: { title: '保存为图片' },
            dataView: { title: '数据视图', readOnly: true },
            magicType: {
              type: ['line', 'bar'],
              title: { line: '折线图', bar: '柱状图' }
            }
          }
        }
      }

      this.chartInstance.setOption(option)
    },

    // 窗口大小改变时重新渲染图表
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },

    // 查询
    handleQuery() {
      if (!this.queryForm.dateRange || this.queryForm.dateRange.length === 0) {
        this.$message.warning('请选择时间范围')
        return
      }
      this.loadStatisticsData()
    },

    // 重置
    handleReset() {
      this.initDateRange()
      this.queryForm.storeIds = ['all']
      this.queryForm.dimension = 'day'
      this.loadStatisticsData()
    },

    // 导出
    handleExport() {
      this.$message.info('导出功能开发中...')
    },

    // 营业额排序方法（按数字大小排序）
    sortByRevenue(a, b) {
      const revenueA = parseFloat(a.revenue) || 0
      const revenueB = parseFloat(b.revenue) || 0
      return revenueA - revenueB
    },

    // 订单数排序方法（按数字大小排序）
    sortByOrderCount(a, b) {
      const countA = parseInt(a.orderCount) || 0
      const countB = parseInt(b.orderCount) || 0
      return countA - countB
    },

    // 客单价排序方法（按数字大小排序）
    sortByAvgAmount(a, b) {
      const avgA = parseFloat(a.avgAmount) || 0
      const avgB = parseFloat(b.avgAmount) || 0
      return avgA - avgB
    }
  }
}
</script>

<style scoped>
.revenue-statistics {
  padding: 20px;
}

.query-form {
  margin-bottom: 0;
}

.summary-card {
  text-align: center;
  padding: 10px 0;
}

.summary-title {
  font-size: 14px;
  color: #909399;
  margin-bottom: 10px;
}

.summary-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

.summary-trend {
  font-size: 14px;
}

.trend-up {
  color: #67C23A;
}

.trend-down {
  color: #F56C6C;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
